// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip-module__tooltip___k0Aq2"};